import { money, linkValue } from '../events/util';

// VENTANA DEL LINK RECIÉN GENERADO.
//
// Antes el link aparecía DEBAJO del botón. En un teléfono quedaba fuera de la pantalla,
// el vendedor no lo veía y volvía a apretar Generar. Y cada link generado CUENTA COMO
// VENTA: esos duplicados por error le inflaban la rendición al RRPP.
//
// Por eso ahora se abre encima, tapa el formulario, y el botón de generar queda
// bloqueado hasta que la persona cierre acá con "Generar otro".
//
// z-index 210: por arriba de .lb-modal-backdrop (200), porque en la pantalla del dueño
// el formulario YA es un modal y esta ventana tiene que quedar por encima.
export default function LinkGenerado({ link, url, copiado, onCopiar, onCompartir, onOtro, onCerrar }) {
  if (!link) return null;
  const cupon = link.coupon_code;
  return (
    <div className="lb-modal-backdrop" style={{ zIndex: 210 }} onClick={onCerrar}>
      <div className="lb-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420, padding: '24px 26px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <span className="lb-eyebrow" style={{ color: '#fff' }}>¡Link listo!</span>
          <button className="lb-iconbtn" onClick={onCerrar}>✕</button>
        </div>

        {link.note && <div style={{ fontSize: 13, color: 'var(--ink-700)', marginBottom: 8 }}>Para: <b style={{ color: '#fff' }}>{link.note}</b></div>}
        {link.lot_name && <div style={{ fontSize: 12, color: 'var(--ink-600)', marginBottom: 8 }}>{link.lot_name} · {link.max_uses} {link.max_uses === 1 ? 'entrada' : 'entradas'}</div>}
        {cupon && (
          <div style={{ fontSize: 12, color: '#2ecc71', marginBottom: 8 }}>
            Cupón <b>{cupon}</b> ({link.coupon_type === 'fixed' ? `${money(link.coupon_value)} off` : `${Number(link.coupon_value)}% off`}) · a 1 entrada
          </div>
        )}
        {/* Lo que el RRPP le descontó la promo, si hubo. Se muestra acá porque es lo que
            va a cobrar y rendir por este link. */}
        {Number(link.promo_discount) > 0 && (
          <div style={{ fontSize: 12, color: '#2ecc71', marginBottom: 8 }}>Promoción aplicada: −{money(link.promo_discount)}</div>
        )}
        {/* El valor del link tal como quedó guardado: sale de linkValue(), la misma cuenta
            que la administración y la rendición. Si entre la cotización y el generar se
            agotó el tope de la promo, acá se ve que el link salió sin ella. */}
        {link.lot_price != null && (
          <div style={{ fontSize: 13, color: 'var(--ink-800)', marginBottom: 8 }}>
            Valor del link: <b style={{ color: '#fff' }}>{money(linkValue(link))}</b>
          </div>
        )}

        <div style={{ fontSize: 12.5, color: 'var(--ink-800)', wordBreak: 'break-all', margin: '12px 0 16px', fontFamily: 'monospace', padding: '10px 12px', background: 'var(--ink-050)', borderRadius: 4 }}>
          {url}
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <button className="lb-btn lb-btn--primary" style={{ flex: 1 }} onClick={onCompartir}>Compartir</button>
          <button className="lb-btn lb-btn--white" style={{ flex: 1 }} onClick={onCopiar}>{copiado ? 'Copiado ✓' : 'Copiar link'}</button>
        </div>
        <button className="lb-btn lb-btn--ghost lb-btn--block lb-btn--sm" style={{ marginTop: 10 }} onClick={onOtro}>+ Generar otro link</button>
      </div>
    </div>
  );
}
